import type { FC } from "react";

/**
 * Typescript decorator to add generic types for functional components
 * */
export const genericDecorator = function <T>(Component: FC<T>): FC<T> {
    // @ts-ignore FIXME: strict migration - Type 'T' is not assignable to 'IntrinsicAttributes & T' — React generic spread limitation
    return (props) => <Component {...props} />;
};
